module.exports = __webpack_public_path__ + "static/media/noOfCompletedApplication.3d3f944e.svg";